<template>
  <div class="mina-foretag">
    <SmallSpinner v-if="individStore.minaForetag.isLoading" />
    <div
      v-if="
        individStore.minaForetag.loaded &&
        individStore.minaForetag.platformError
      "
    >
      <avtalat-message type="negative"
        ><p>Misslyckades att hämta arbetsgivarrepresentantens företag.</p>
      </avtalat-message>
    </div>
    <avtalat-accordion
      v-if="minaForetag.length > 0 && !individStore.minaForetag.platformError"
    >
      <avtalat-accordion-item
        :heading="`Välj arbetsgivare<span class='number'>${minaForetag.length}</span>`"
        :loading="individStore.minaForetag.isLoading"
      >
        <hr />
        <avtalat-table :headings="headings" :striped="false">
          <avtalat-table-row
            v-for="(foretag, index) in minaForetag"
            :key="index"
            :highlighted="
              foretag.organisationsnummer ===
              arbetsgivareStore.arbetsgivare.foretag?.organisationsnummer
            "
          >
            <avtalat-table-cell>{{
              foretag.organisationsnummer
            }}</avtalat-table-cell>
            <avtalat-table-cell>{{ foretag.namn }}</avtalat-table-cell>
            <avtalat-table-cell>
              <router-link
                v-if="!individStore.kundkontaktkort.isCreating"
                :to="{
                  path: 'arbetsgivare',
                  query: {
                    tab: 'arbetsgivare',
                    organisationsnummer: foretag.organisationsnummer,
                    verified: individStore.verification.isVerified.toString(),
                  },
                }"
              >
                <avtalat-icon id="pil-hoger-1" color="teal-400" />
              </router-link>
            </avtalat-table-cell>
          </avtalat-table-row>
        </avtalat-table>
      </avtalat-accordion-item>
    </avtalat-accordion>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import SmallSpinner from "@/components/ui/SmallSpinner.vue";
import type { MinaForetag } from "@/composables/KundserviceAppApiClient";
import { useIndividStore } from "@/stores";

import { useArbetsgivareStore } from "./store";

const arbetsgivareStore = useArbetsgivareStore();
const individStore = useIndividStore();
const headings = [
  { content: "Org.nr.", disableSorting: true },
  { content: "Namn", disableSorting: true },
  { content: "", disableSorting: true },
];

const minaForetag = computed(
  () => (individStore.minaForetag.data as MinaForetag[]) || [],
);
</script>

<style type="css">
.center {
  text-align: center;
}

.mina-foretag {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.mina-foretag details {
  border: 0;
  border-radius: 6px;
  background-color: var(--neutral-50);
  padding: 0;
  width: 100%;
}

.mina-foretag summary {
  padding: 12px 25px;
}

.mina-foretag summary .number {
  display: inline-block;
  margin-left: 10px;
  border-radius: 50%;
  background: var(--border-brand);
  padding-top: 2px;
  width: 28px;
  height: 28px;
  color: var(--white);
  text-align: center;
}

.mina-foretag hr {
  margin: -15px 25px 15px 25px;
  border-top: 1px solid var(--neutral-200);
  width: calc(100% - 50px);
}

.mina-foretag table {
  margin: 0 25px 25px 25px;
  padding-top: 20px;
  width: calc(100% - 50px);
}
</style>
